import React, { useRef, useEffect, useState } from 'react';
import { BaseButton, useT } from '@repo/common';

import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

function ReasonSelect({
  onSelect,
  selectedOption,
  options = [],
  isMyPagePersonalInfo = false,
}) {
  const t = useT();
  const optionLabelsKr = {
    'Select role': '직무 선택',
    Design: '디자인',
    Manufacturing: '제조',
    IT: 'IT',
    Business: '비즈니스',
    Marketing: '마케팅',
    Education: '교육',
    Trade: '무역',
    'Sales & CS': '영업·고객 지원',
    Service: '서비스',
    Construction: '건설',
    Entertainment: '엔터테인먼트',
    'Interpretation & Translation': '통·번역',
    'R&D': '연구개발',
    'Other (Enter manually)': '기타 (직접 입력)',
  };
  const fallbackOptions = [
    'Select role',
    'Design',
    'Manufacturing',
    'IT',
    'Business',
    'Marketing',
    'Education',
    'Trade',
    'Sales & CS',
    'Service',
    'Construction',
    'Entertainment',
    'Interpretation & Translation',
    'R&D',
    'Other (Enter manually)',
  ];
  const optionLabels =
    options.length > 0
      ? options.map((option) => option.optionLabel).filter(Boolean)
      : fallbackOptions;

  const listRef = useRef(null);
  const selectedRef = useRef(null);
  const [localSelected, setLocalSelected] = useState(selectedOption);

  useEffect(() => {
    const c = listRef.current;
    const s = selectedRef.current;
    if (c && s) c.scrollTop = s.offsetTop - 8;
  }, [selectedOption]);

  useEffect(() => {
    setLocalSelected(selectedOption);
  }, [selectedOption]);

  return (
    <div
      ref={listRef}
      className={`w-full relative ${isMyPagePersonalInfo ? 'h-[206px]' : 'h-[246px]'} overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02`}
    >
      <ul role='menu' className='p-0 m-0 list-none'>
        {optionLabels.map((option) => {
          const isSelected = option === localSelected;

          return (
            <div
              key={option}
              ref={isSelected ? selectedRef : null}
              className='flex items-center transition-colors duration-150 rounded-lg'
            >
              <BaseButton
                type='text'
                size='m'
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onMouseDown={() => {
                  setLocalSelected(option);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setLocalSelected(option);
                  onSelect(option);
                }}
                leftalign='true'
                icon={
                  isSelected ? (
                    <CheckIcon className='text-icon-primary' />
                  ) : (
                    <span className='w-4 h-[18px]' />
                  )
                }
              >
                {t(option, optionLabelsKr[option] || option)}
              </BaseButton>
            </div>
          );
        })}
      </ul>
    </div>
  );
}

export default ReasonSelect;
